import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";  
import { useTranslation } from "react-i18next";


import { getEmployeRequests } from "../../../MyApi/hr/employerequests";

import LoadingSpinner from "../../UI/spinner";
import SingleRequest from "../singleRequest";







const RequestsCard = () => {

  const { data, isLoading , refetch} = useQuery("getRequest", getEmployeRequests);
  const {t}= useTranslation()
   const navigate = useNavigate()

  const requestsData = data?.data || [];

  const navigateShow = (id) => {
    navigate(`${process.env.PUBLIC_URL}/employerequests/${id}`)
  };


  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div class="card">
      <div class="card-header">
        <h5>الطلبات</h5>
      </div>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("Name")}</th>
              <th>{t("Request")}</th>
              <th>{t("Date")}</th>
              <th>{t("Status")}</th>
              <th>{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
          {requestsData.map((request) => (
      
      <SingleRequest   key={request.id } {...request}  navigateShow={navigateShow} t={t} refetch={refetch}  /> 
       
       ))}
          </tbody>
        </table>
    </div>
    </div>
  );
};

export default RequestsCard;
